"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var useIsMounted = function () {
    var mountedRef = react_1.default.useRef(false);
    react_1.default.useEffect(function () {
        mountedRef.current = true;
        return function () {
            mountedRef.current = false;
        };
    }, []);
    return mountedRef;
};
exports.default = useIsMounted;
//# sourceMappingURL=use-is-mounted.js.map